import React, { useState } from 'react';
import { Tooltip } from '@mui/material';
import { RemoveRedEye } from '@mui/icons-material';
import { useSelector } from 'react-redux';

export const MultiUserTaskIndicator = props => {
  const { taskId } = props;
  const [selectedUserCustomList] = useState(window.USER.id);
  const userWorkingList = useSelector(state => state.socketReducer.usersWorkingTasks);

  const userWithTasks = userWorkingList.map(x => ({
    id: x.id,
    name: x.name,
    tasks: x.patient?.flatMap(t => t.tasks),
  }));

  const usersWithThisTask = userWithTasks.filter(
    x => x.tasks?.some(t => t === taskId) && x.id !== selectedUserCustomList,
  );

  const uniqueUsers = usersWithThisTask.reduce((acc, user) => {
    if (!acc.find(u => u.id === user.id)) {
      acc.push(user);
    }
    return acc;
  }, []);

  const hasOtherUsers = uniqueUsers.length > 0;
  const iconColor = hasOtherUsers ? '#c78a80' : '#70777a44';

  return (
    <Tooltip
      title={uniqueUsers.map(item => (
        <div key={`user-${item.id}`}>{item.name}</div>
      ))}
    >
      <div style={{ width: '26px', height: '20px' }}>
        <RemoveRedEye
          style={{
            fill: iconColor,
            fontSize: '20px',
            marginRight: 6,
            transform: 'translateY(-1px)',
          }}
        />
      </div>
    </Tooltip>
  );
};
